<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-button
          style="padding: 0; margin: 20px"
          type="text"
          icon="el-icon-back"
          @click="$router.go(-1)"
        >
          返回
        </el-button>
        <el-button
          type="primary"
          size="mini"
          @click="search.chooseOrgVisible = true; searchCourseData()"
        >
          添加
        </el-button>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24">
        <h2 style="margin-top: 0;">中奖用户列表</h2>
      </el-col>
      <el-table
        v-loading="loading"
        :data="list"
        border
        size="mini"
        :stripe="true"
        style="width: 100%; margin: 20px 0"
      >
        <el-table-column
          prop="user_id"
          label="用户ID"
          align="center"
        ></el-table-column>
        <el-table-column
            prop="nickname"
            label="用户昵称"
            align="center"
        ></el-table-column>
        <el-table-column prop="avatar" label="头像" width="100">
          <template slot-scope="{row}">
            <img  :src="row.avatar" alt="" style="width: 50px;height: 50px">
          </template>

        </el-table-column>
        <el-table-column
            prop="total_consume"
            label="累计消费"
            align="center"
        >
          <template slot-scope="{ row }">
            <div>￥{{ row.total_consume}}</div>
          </template>
        </el-table-column>
        <el-table-column
            prop="mobile_phone"
            label="用户手机号"
            align="center"
        ></el-table-column>
        <el-table-column label="角色" align="center">
          <template slot-scope="{ row }">
            <div>{{ row.role == 1 ? '队长' : '队员' }}</div>
          </template>
        </el-table-column>

        <el-table-column label="用户类型" align="center">
          <template slot-scope="{ row }">
            <div>{{ row.user_type == 1 ? '旧' : '新' }}</div>
          </template>
        </el-table-column>
        <el-table-column
            prop="users_num_count"
            label="奖码数"
            align="center"
        ></el-table-column>
        <el-table-column
          prop="lottery_code"
          label="抽奖码"
          align="center"
        ></el-table-column>
        <el-table-column
            prop="created_at"
            label="注册时间"
            align="center"
        ></el-table-column>

        <el-table-column label="操作" align="center" width="100">
          <template slot-scope="{ row }">
            <el-button
              type="danger" icon="el-icon-delete" circle
              @click="deleteActivityWinner(row.id)"
            >
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <div class="block">
        <el-pagination
          background
          @current-change="getList"
          :current-page.sync="query.page"
          :page-size="query.limit"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </el-row>

    <el-dialog
      title="添加中奖人"
      :visible.sync="search.chooseOrgVisible"
      :close-on-click-modal="true"
      :before-close="addEditFormOnClose"
      width="75%"
    >
      <el-form :inline="true" :model="search.query">
        <!-- 模糊查询 -->
        <el-form-item>
          <el-input
            v-model="search.query.mobile_phone"
            placeholder="请输入用户手机号"
            clearable
          />
        </el-form-item>
        <!--查询按钮-->
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="searchCourseData()"
            :loading="search.listLoading1"
            >搜索</el-button
          >
        </el-form-item>
      </el-form>

      <!--列表-->
      <el-table
        border
        :data="search.result.data"
        highlight-current-row
        v-loading="search.listLoading1"
        style="..."
      >
        <el-table-column
            prop="user_id"
            label="用户ID"
            align="center"
        ></el-table-column>
        <el-table-column
            prop="nickname"
            label="用户昵称"
            align="center"
        ></el-table-column>
        <el-table-column prop="avatar" label="头像" width="100">
          <template slot-scope="{row}">
            <img  :src="row.avatar" alt="" style="width: 50px;height: 50px">
          </template>

        </el-table-column>
        <el-table-column
            prop="total_consume"
            label="累计消费"
            align="center"
        >
          <template slot-scope="{ row }">
            <div>￥{{ row.total_consume}}</div>
          </template>
        </el-table-column>
        <el-table-column
            prop="mobile_phone"
            label="用户手机号"
            align="center"
            width="120"
        ></el-table-column>
        <el-table-column label="角色" align="center">
          <template slot-scope="{ row }">
            <div>{{ row.role == 1 ? '队长' : '队员' }}</div>
          </template>
        </el-table-column>

        <el-table-column label="用户类型" align="center">
          <template slot-scope="{ row }">
            <div>{{ row.user_type == 1 ? '旧' : '新' }}</div>
          </template>
        </el-table-column>
        <el-table-column
            prop="users_num_count"
            label="奖码数"
            align="center"
        ></el-table-column>
        <el-table-column
            prop="lottery_code"
            label="抽奖码"
            align="center"
        ></el-table-column>
        <el-table-column
            prop="created_at"
            label="注册时间"
            align="center"
            width="180"
        ></el-table-column>

        <el-table-column label="操作" align="center" width="100">
          <template slot-scope="{ row }">
            <el-button
              type="primary"
              size="small"
              @click="addActivityWinner(row.id)"
            >
              添加
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @current-change="searchCourseData"
        :current-page.sync="search.query.page"
        :page-size="search.query.limit"
        layout="total, prev, pager, next, jumper"
        :total="search.result.total"
      >
      </el-pagination>
    </el-dialog>

    <!-- 二维码弹窗 -->
    <el-dialog
      title="遇见活动推广课程二维码"
      :visible.sync="dialogVisible"
      width="50%"
    >
      <div id="qrcode" style="margin-left: 256 /2; position: relative; left: 10%"></div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { qrCode } from "@/api/common";
import {
  chakrasUserList,
  updateChakrasWinner,
  relationCourseQrcode,
} from "@/api/activityChakras";

export default {
  data: function () {
    return {
      dialogVisible: false,
      list: [],
      loading: false,
      total: 0,
      query: {
        activity_id: 0,
        winning_status: 1,
        page: 1,
        limit: 20,
      },

      search: {
        chooseOrgVisible: false,
        listLoading1: false,
        query: {
          activity_id: 0,
          mobile_phone: "",
          page: 1,
          limit: 100,
          winning_status: 0
        },
        result: {
          total: 0,
          data: [],
        },
      },
    };
  },
  mounted() {},
  created: function () {
    this.query.activity_id = this.$route.query.activity_id;
    this.query.winning_status = this.$route.query.winning_status;
    this.search.query.activity_id = this.$route.query.activity_id;
    this.getList();
  },
  methods: {
    activityCourseQrcode(course_id, type) {
      relationCourseQrcode({
        activity_id: this.$route.query.activity_id,
        type: type,
        course_id: course_id,
      }).then((response) => {
        if (response.status == 2000) {
          this.dialogVisible = true;
          this.$nextTick(function () {
            document.getElementById("qrcode").innerHTML = "";
            let qrcode = qrCode(response.data.qrcode);
          });
        } else {
          this.$message({
            showClose: true,
            message: response.message,
            type: "error",
          });
        }
      });
    },
    addActivityWinner(id) {
      updateChakrasWinner({
        activity_id: this.$route.query.activity_id,
        id: id,
        type:1
      }).then((response) => {
        if (response.status == 2000) {
          this.$message({
            showClose: true,
            message: "添加成功",
            type: "success",
          });
          this.addEditFormOnClose();
          this.getList();
        } else {
          this.$message({
            showClose: true,
            message: response.message,
            type: "error",
          });
        }
      });
    },

    getList() {
      this.query.activity_id = this.query.activity_id;
      //this.query.activity_id = this.$route.query.activity_id;
      this.query.winning_status = this.query.winning_status;
      this.loading = true;
      chakrasUserList(this.query).then((response) => {
        this.list = response.data.list;
        this.total = response.data.total;
        this.loading = false;
      });
    },

    deleteActivityWinner(id) {
      this.$confirm("确定执行删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        updateChakrasWinner({
          activity_id: this.$route.query.activity_id,
          id: id,
          type:0
        }).then((response) => {
          if (response.status == 2000) {
            this.getList();
            this.$message({
              showClose: true,
              message: "删除成功",
              type: "success",
            });
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
        });
      });
    },

    // 弹窗关闭
    addEditFormOnClose() {
      this.search.query.mobile_phone = "";
      this.search.result = [];
      this.search.chooseOrgVisible = false;
    },
    // 选中行
    rowClick(row, event, column) {
      this.nowClickRow = row;
      console.log(row);
    },
    // 查询方法
    searchCourseData() {
      this.search.result = {
        total: 0,
          data: [],
      };
      chakrasUserList(this.search.query).then((response) => {
        this.search.result.data = response.data.list;
        this.search.result.total = response.data.total;
        this.loading = false;
      });
    },
  },
};
</script>